// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "725e6a03" + "." + "3e9536ce3c512591" + ".js";
};